/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Favorites_YetInputs */

const en_no_favorites_yet = /** @type {(inputs: No_Favorites_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No favorites yet`)
};

const es_no_favorites_yet = /** @type {(inputs: No_Favorites_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay favoritos`)
};

const fr_no_favorites_yet = /** @type {(inputs: No_Favorites_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun favori pour le moment`)
};

const de_no_favorites_yet = /** @type {(inputs: No_Favorites_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Favoriten`)
};

const id_no_favorites_yet = /** @type {(inputs: No_Favorites_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada favorit`)
};

/** @type {(inputs: No_Favorites_YetInputs) => LocalizedString} */
const ja_no_favorites_yet = en_no_favorites_yet;

/** @type {(inputs: No_Favorites_YetInputs) => LocalizedString} */
const zh_no_favorites_yet = en_no_favorites_yet;

/** @type {(inputs: No_Favorites_YetInputs) => LocalizedString} */
const ar_no_favorites_yet = en_no_favorites_yet;

/** @type {(inputs: No_Favorites_YetInputs) => LocalizedString} */
const it_no_favorites_yet = en_no_favorites_yet;

/** @type {(inputs: No_Favorites_YetInputs) => LocalizedString} */
const ru_no_favorites_yet = en_no_favorites_yet;

/** @type {(inputs: No_Favorites_YetInputs) => LocalizedString} */
const pt_no_favorites_yet = en_no_favorites_yet;

/** @type {(inputs: No_Favorites_YetInputs) => LocalizedString} */
const ko_no_favorites_yet = en_no_favorites_yet;

/**
* | output |
* | --- |
* | "No favorites yet" |
*
* @param {No_Favorites_YetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_favorites_yet = /** @type {((inputs?: No_Favorites_YetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Favorites_YetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_favorites_yet(inputs)
	if (locale === "es") return es_no_favorites_yet(inputs)
	if (locale === "fr") return fr_no_favorites_yet(inputs)
	if (locale === "de") return de_no_favorites_yet(inputs)
	if (locale === "ja") return ja_no_favorites_yet(inputs)
	if (locale === "zh") return zh_no_favorites_yet(inputs)
	if (locale === "ar") return ar_no_favorites_yet(inputs)
	if (locale === "id") return id_no_favorites_yet(inputs)
	if (locale === "it") return it_no_favorites_yet(inputs)
	if (locale === "ru") return ru_no_favorites_yet(inputs)
	if (locale === "pt") return pt_no_favorites_yet(inputs)
	return ko_no_favorites_yet(inputs)
});